<div class="container mt-5 mb-5">

    <span class="display-5 font-weight-semi-bold mt-1 mb-1">{{ 'Page_FAQ_Title' | translate }}</span>
    
    <div *ngFor="let group of groups; let i = index">
        <h1 class="font-weight-semi-bold mt-3 mb-3">{{ group.groupName | translate }}</h1>
        <app-accordion [groupId]="i" [items]="group.items" [openedFragment]="route.fragment | async "></app-accordion>
    </div>

</div>